module.exports = __webpack_public_path__ + "img/empty.b7052687.png";